import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Drop-in replacement for ng-block-ui's service, Angular 22-native.
 * Tracks active/blocked state and an optional message per named block.
 * (ng-block-ui@4.0.1 is abandoned and uses ComponentFactoryResolver, removed in Angular 22.)
 */
@Injectable({ providedIn: 'root' })
export class BlockUIService {
  private readonly state = new Map<string, BehaviorSubject<{ active: boolean; message?: string }>>();

  private subject(name: string): BehaviorSubject<{ active: boolean; message?: string }> {
    let s = this.state.get(name);
    if (!s) {
      s = new BehaviorSubject<{ active: boolean; message?: string }>({ active: false });
      this.state.set(name, s);
    }
    return s;
  }

  /** Observable of a named block's state (used by the *blockUI directive). */
  observe(name: string): Observable<{ active: boolean; message?: string }> {
    return this.subject(name).asObservable();
  }

  start(name: string, message?: string): void {
    this.subject(name).next({ active: true, message });
  }

  stop(name: string): void {
    this.subject(name).next({ active: false });
  }
}
